const cardConfigurationsTranslations = {
  es: {
    table: {
      breadcrumbs: {
        title: 'Configuración de tarjetas',
        description: 'Administración de configuraciones.'
      },
      headers: {
        'account': 'Cuenta',
        'bank': 'Banco',
        'card': 'Tarjeta',
        'card_type': 'Tipo de Tarjeta',
        'from': 'Desde',
        'until': 'Hasta',
        'interests': 'Intereses',
      },
      filters: {
        title: 'Refinar búsqueda',
        account: 'Cuenta',
        bank: 'Banco',
        card: 'Tarjeta',
        dates: 'Fechas',
        interests: 'Intereses',
      },
      message: {
        delete: '¿Estás seguro de eliminar?',
        title: 'Estás a punto de eliminar las siguientes configuraciones',
        deleteAction: 'Si, eliminar',
        cancelAction: 'Cancelar',
        actions: 'Acciones'
      },
      search: {
        search: 'Buscar',
        gotopage: 'Ir a página',
        edit: 'Editar',
        delete: 'Eliminar',
        details: 'Detalles',
        bulkDelete: 'Eliminar configuraciones',
      },
      error_message: {
        dates_error: 'El rango de fechas es inválido.',
        delete_message: 'No se puede eliminar la configuración',
        bulk_delete_message: 'No se pueden eliminar las configuraciones',
      },
      filters_asidebar: {
        'account': 'Cuenta',
        'bank': 'Banco',
        'card': 'Tarjeta',
        'dates': 'Fechas',
        'interests': 'Intereses',
      }
    },
    create: {
      breadcrumbs: {
        title: 'Nueva configuración de tarjetas',
        description: 'Crea una nueva configuracion de tarjetas'
      },
      cardConfiguration: {
        account: {
          title: 'Cuenta',
          subtitle: 'Seleccione una cuenta'
        },
        bank: {
          title: 'Banco',
          subtitle: 'Seleccione un banco'
        },
        card: {
          title: 'Tarjeta',
          subtitle: 'Ingrese el nombre de la tarjeta'
        }
      },
      dates: {
        title: 'Fecha',
        start: 'Inicio',
        end: 'Fin'
      },
      disclaimerInterest: {
        title: 'Intereses',
        disclaimerText: 'Al dejar vacío el siguiente cuadro, se mostrará un cartel que indique "Sin Interés" al momento de hacer una compra con esta configuración'
      }
    },
    update: {
      breadcrumbs: {
        title: 'Edicion de configuración de tarjetas',
        description: 'Edita la configuracion.'
      },
      cardConfiguration: {
        account: {
          title: 'Cuenta',
          subtitle: 'Seleccione una cuenta'
        },
        bank: {
          title: 'Banco',
          subtitle: 'Seleccione un banco'
        },
        card: {
          title: 'Tarjeta',
          subtitle: 'Ingrese el nombre de la tarjeta'
        }
      },
      dates: {
        title: 'Fecha',
        start: 'Inicio',
        end: 'Fin'
      },
      disclaimerInterest: {
        title: 'Intereses',
        disclaimerText: 'Al dejar vacío el siguiente cuadro, se mostrará un cartel que indique "Sin Interés" al momento de hacer una compra con esta configuración'
      }
    }
  },
  en: {

  },
};

export { cardConfigurationsTranslations };
export default cardConfigurationsTranslations;